import { connect } from 'formik'
import { IntlShape, useIntl } from 'react-intl'
import { array, object, string } from 'yup'

import AudienceTargeting from '@/components/Form/AudienceTargeting'
import VariableInput from '@/pages/SpaceAppBuilder/components/VariableInput/VariableInput'
import { useWorkflowFeature } from '@/pages/SpaceAppBuilder/FeaturesPage/WorkflowFeatureContext'
import { DeleteNotificationStepData, StepData } from '@/pages/SpaceAppBuilder/utilities/interfaces'

import messages from './messages'

//<editor-fold desc="Interfaces">
type DeleteNotificationProps = {
  readOnly?: boolean
  formik?: any
}
//</editor-fold>

const getValidationSchema = (intl: IntlShape) => {
  return {
    correlationId: string().required(intl.formatMessage(messages.deleteNotificationIdRequired)),
    audience: array()
      .of(
        object().shape({
          filters: array().of(
            object().shape({
              attribute: object().required().label('Audience Targeting Attribute'),
              operator: string().required().label('Audience Targeting Operator'),
              value: string().required().label('Audience Targeting Value')
            })
          )
        })
      )
      .notRequired()
  }
}

const getInitialValues = (stepData: DeleteNotificationStepData): StepData => ({
  correlationId: stepData.correlationId ?? '',
  audience: stepData.audience
})
const getDeleteOperationHelpUrl = 'https://help.workgrid.com/s/article/Deleting-a-Notification-in-Workshop'

const DeleteOperation = ({ readOnly }: DeleteNotificationProps) => {
  const intl = useIntl()

  const { getVariablesForStep } = useWorkflowFeature()
  const variables = getVariablesForStep()

  return (
    <>
      <VariableInput
        name={`stepData.correlationId`}
        label={intl.formatMessage(messages.deleteNotificationIdLabel)}
        placeholder={intl.formatMessage(messages.deleteNotificationIdPlaceholder)}
        variables={variables}
        required={true}
        readOnly={readOnly}
      />
      <div style={{ marginTop: '15px', fontWeight: 'bold', fontSize: '1.25em' }}>
        {intl.formatMessage(messages.audienceTargeting)}
      </div>
      <AudienceTargeting
        readOnly={readOnly}
        required={false}
        variables={variables}
        rulePrefixText={intl.formatMessage(messages.deleteNotificationAudienceRulePrefixText)}
        name="stepData.audience"
        title={''}
        startWithAudience={false}
        firstFilterMandatory={false}
      />
    </>
  )
}

DeleteOperation.displayName = 'DeleteOperation'

export default connect(DeleteOperation)

export { getInitialValues, getValidationSchema, getDeleteOperationHelpUrl }
